export default "__VITE_ASSET__B5iSW0aU__"